import { Formik, Form, Field } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ButtonLoader from "@/Components/ButtonLoader";
import FieldErrorMessage from "@/Components/common/FieldErrorMessage";
import { RequiredSymbol } from "@/Components/common/RequiredSymbol";
import {
  updateEditActiveStep,
  updateRoleAccessData,
} from "@/reducers/client_user/roleAccess";
import { roleAccessValidation } from "@/utilities/CommonText";

const EditRoleBasicInfo = () => {
  const { roleAccessData } = useSelector((state) => state.clientRoles);
  const dispatch = useDispatch();

  return (
    <div className="JobDetails_Wrapper mb-14 grid gap-4">
      <div className="">
        <div className="grid gap-4">
          <div className="rounded-lg bg-white p-6">
            <div className="mb-4 flex justify-between">
              <h4 className="text-[18px] font-medium leading-[normal] text-black">
                Role Details
              </h4>
            </div>
            <div>
              <div>
                <Formik
                  initialValues={{
                    roleName: roleAccessData.roleName,
                    roleDescription: roleAccessData.roleDescription,
                  }}
                  validateOnMount={false}
                  validateOnChange={false}
                  validateOnBlur={false}
                  validate={(values) => {
                    let errors = {};
                    if (!values.roleName || values.roleName == null) {
                      errors.roleName = roleAccessValidation.roleName;
                    }
                    return errors;
                  }}
                  enableReinitialize={true}
                  onSubmit={(values, { setSubmitting }) => {
                    dispatch(updateEditActiveStep(2));
                    setSubmitting(false);
                  }}
                >
                  {({
                    submitForm,
                    isSubmitting,
                    errors,
                    touched,
                    isValid,
                    values,
                    setFieldValue,
                    validateForm,
                  }) => (
                    <Form>
                      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <div>
                          <div className="flex flex-col gap-3">
                            <label className="label" htmlFor="roleName">
                              Role Name <RequiredSymbol />
                            </label>
                            <Field
                              id="roleName"
                              name="roleName"
                              type="text"
                              placeholder="Enter Role Name"
                              className="ease h-[40px] w-full rounded-lg border border-lightGrey px-4 text-[14px] font-medium leading-[normal] text-black transition-all duration-200 placeholder:font-medium placeholder:text-txtColor focus:border-primary"
                              onChange={(e) => {
                                setFieldValue("roleName", e.target.value);
                                dispatch(
                                  updateRoleAccessData({
                                    ...roleAccessData,
                                    roleName: e.target.value,
                                  }),
                                );
                              }}
                              onKeyUp={(e) => {
                                if (touched.roleName && errors.roleName) {
                                  validateForm();
                                }
                              }}
                            />
                          </div>
                          <FieldErrorMessage
                            name="roleName"
                            className={"text-red"}
                          />
                        </div>
                        <div>
                          <div className="flex flex-col gap-3">
                            <label className="label" htmlFor="roleDescription">
                              Role Description
                            </label>
                            <Field
                              as="textarea"
                              id="roleDescription"
                              name="roleDescription"
                              placeholder="Enter Role Description"
                              className="ease max-h-[400px] min-h-[40px] w-full rounded-lg border border-lightGrey px-4 py-2 text-[14px] font-medium leading-[normal] text-black transition-all duration-200 placeholder:font-medium placeholder:text-txtColor focus:border-primary"
                              onChange={(e) => {
                                setFieldValue(
                                  "roleDescription",
                                  e.target.value,
                                );
                                dispatch(
                                  updateRoleAccessData({
                                    ...roleAccessData,
                                    roleDescription: e.target.value,
                                  }),
                                );
                              }}
                              value={values.roleDescription}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-end">
                        <button
                          className="ease relative mt-5 h-[40px] w-[120px] rounded-lg border border-primary bg-primary text-[14px] font-medium leading-[38px] text-white transition-all duration-200 hover:bg-none hover:text-primary"
                          onClick={() => {
                            submitForm();
                          }}
                          type="button"
                          disabled={isSubmitting || !isValid}
                        >
                          {isSubmitting ? <ButtonLoader /> : <span>Next</span>}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRoleBasicInfo;
